import { useCallback, useState } from "react";
import { useGlobalContext } from "../Context/GlobalContext";

export const useLogin = () => {
  const { api } = useGlobalContext();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const loginGateway = useCallback(
    async ({ number, otp = "", step = "1" }) => {
      if (!api) {
        throw new Error("API instance is not available.");
      }

      try {
        setLoading(true);
        setError("");

        const payload = {
          number: String(number || "").trim(),
          otp: String(otp || "").trim(),
          step: String(step),
        };

        const response = await api.post("/Chaafo/logINGateway", payload);

        return response?.data;
      } catch (requestError) {
        console.error(
          "Login API error:",
          requestError?.response?.data || requestError,
        );

        const responseData = requestError?.response?.data;

        const message =
          typeof responseData === "object"
            ? responseData?.responseMessage ||
              "Unable to process login request."
            : requestError?.message || "Unable to process login request.";

        setError(message);

        throw new Error(message);
      } finally {
        setLoading(false);
      }
    },
    [api],
  );

  return {
    loginGateway,
    loading,
    error,
    setError,
  };
};
